import { render } from "./Compare.vue?vue&type=template&id=325b9aaa&scoped=true"
import script from "./Compare.vue?vue&type=script&lang=js"
export * from "./Compare.vue?vue&type=script&lang=js"

import "./Compare.vue?vue&type=style&index=0&id=325b9aaa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325b9aaa"]])

export default __exports__